// /Users/pramod/Desktop/school-erp/frontend/src/Tenant-Admin/ManageStaff/StaffGrid.js
import React from 'react';
import StaffCard from './StaffCard';
import { CheckSquare } from 'lucide-react';

const StaffGrid = ({
  staff,
  selectedStaffIds,
  selectAll,
  onSelectStaff,
  onSelectAll,
  onEdit,
  onStatusToggle,
  onDelete,
  onViewDetails
}) => {
  if (staff.length === 0) return null;

  return (
    <div className="bg-white rounded-xl overflow-hidden">
      
      {/* Clean Low-Profile Table Header */}
      <div className="bg-slate-50/50 px-4 py-3 sm:px-6 sm:py-3.5 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={onSelectAll}
            className="h-4 w-4 rounded-md border-slate-300 text-slate-900 focus:ring-slate-900 focus:ring-1"
          />
          <span className="text-xs font-bold text-slate-500 uppercase tracking-wider select-none">
            Select All Profiles
          </span>
        </div>
        
        {/* Selection Badge Stream Indicator */}
        {selectedStaffIds.length > 0 && (
          <div className="flex items-center gap-1.5 text-[11px] font-bold text-indigo-600 bg-indigo-50/50 px-2 py-0.5 rounded-md">
            <CheckSquare size={12} />
            <span>{selectedStaffIds.length} Flagged</span>
          </div>
        )}
      </div>

      {/* Staff Cards Scroll Section List Wrapper */}
      <div className="divide-y divide-slate-100">
        {staff.map((member) => (
          <StaffCard
            key={member.userId || member._id}
            member={member}
            selected={selectedStaffIds.includes(member.userId || member._id)}
            onSelect={() => onSelectStaff(member.userId || member._id)}
            onEdit={() => onEdit(member)}
            onStatusToggle={() => onStatusToggle(
              member.userId || member._id, 
              `${member.firstName} ${member.lastName || ''}`.trim(),
              member.status
            )}
            onDelete={() => onDelete(
              member.userId || member._id, 
              `${member.firstName} ${member.lastName || ''}`.trim()
            )}
            onViewDetails={() => onViewDetails(member)}
          />
        ))}
      </div>
      
    </div>
  );
};

export default StaffGrid;